import { css } from '@emotion/core';
import { rgba, variables as vars, media } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font,
  global = vars.global;
export var popup = /*#__PURE__*/css("display:inline-block;position:absolute;border:1px solid ", colour.neutral100, ";pointer-events:auto;background-color:", colour.white, ";box-shadow:0 1px 8px 0 ", rgba(colour.black, 0.15), ";z-index:", Number(global.layerFloating) + 1, ";min-width:290px;min-height:165px;width:290px;top:45px;left:-228px;", media('>=tablet'), "{left:-150px;}&::after,&::before{bottom:100%;left:90%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;border-color:", rgba(colour.white, 0), ";}&::before{border-bottom-color:", colour.neutral200, ";border-width:10px;margin-left:-10px;top:-21px;}&::after{border-bottom-color:", colour.white, ";border-width:10px;margin-left:-10px;}");
export var title = /*#__PURE__*/css("margin-top:30px;color:", colour.allhomesNavy600, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";font-weight:600;line-height:1.5;text-align:left;");
export var message = /*#__PURE__*/css("margin-top:2px;color:", colour.allhomesNavy600, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";line-height:1.43;text-align:left;");
export var closeButton = /*#__PURE__*/css("position:absolute;top:4px;right:2px;background:none;border:0;color:", colour.neutral400, ";");
export var buttonGroup = {
  name: "13brihr",
  styles: "text-align:left;"
};
export var button = /*#__PURE__*/css("font-size:", font.smallFontSize, ";padding:0;");
export var content = {
  name: "vw2287",
  styles: "display:flex;align-items:center;flex-direction:row;padding:0 15px;"
};
export var contentMiddle = {
  name: "1isemmb",
  styles: "margin-left:8px;"
};